export const adminRoutes = ['tcs200', 'organizations', 'dashboard']
